<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: false
  },
  customstyle: {
    type: String,
    required: false
  },
  additionaltext: {
    type: String,
    required: false
  },
  customstyleTitle: {
    type: String,
    required: false
  }
})
</script>

<template>
  <div class="flex flex-col">
    <h1 :class="customstyleTitle">
      {{ props.title }}
    </h1>
    <p v-if="props.description" :class="props.customstyle">
      <span> {{ props.description }}</span>
      <span class="color-secondary-700 ml-1 text-lg font-bold leading-7">{{
        props.additionaltext
      }}</span>
    </p>
  </div>
</template>
